import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ActionButton } from '../../../../components/action-button';
import { useEntityDelete } from '../../../entities/hooks';
import { fetchFAQDelete } from '../../thunks';
import { IconDeleteCanOutline } from '../../../../common/icons';
import { ROUTE_FAQ } from '../../../../common/constants';
import { IFAQ } from '../../models';

interface FAQActionDeleteProps {
  id: IFAQ['id'];
}

export const FAQActionDelete: FC<FAQActionDeleteProps> = ({ id }) => {
  const { t } = useTranslation();
  const { handleDelete } = useEntityDelete({
    thunk: fetchFAQDelete,
    nextPath: ROUTE_FAQ,
    confirmationText: t('confirmation.delete.text'),
  });

  return (
    <ActionButton
      onClick={() => handleDelete(id)}
      title={t('action.delete')}
      icon={<IconDeleteCanOutline />}
    />
  );
};
